<template>
  <div class="continer">
    <ul>
      <li>
        <!-- <h4>一、中心资质</h4> -->
        <p>
          {{this.projectList.content}}
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
import {honor_query} from '../../api/user/index'
import {ERR_OK} from '../../api/common/config'
export default {
  data() {
    return {
      projectList:{}
    }
  },
  mounted() {
    this._honor_query()
  },
  methods: {
    _honor_query () {
      honor_query().then((res)=>{
        if(res.data.isok === ERR_OK) {
          this.projectList = res.data.data
          // console.log(this.projectList)
        }
      })
    }
  },
}
</script>
<style lang="stylus" scoped>
.continer 
  width 100%
  color #333
  li 
    h4 
      font-size 14px
    p 
      font-size 12px
</style>
